import * as React from "react";
import { NavLink, Redirect } from "react-router-dom";
import { withTranslation } from "react-i18next";
import CoreComponent from "./CoreComponent";
import { IHolder, IUser } from "../interfaces";
import config from "../config";
import Axios from "axios";
import { connect } from "react-redux";
import UserModal from "../components/UserModal";
import { toast } from "react-toastify";

interface IState {
    supers: IUser[],
    admins: IUser[],
    moderators: IUser[],
    isLoading: boolean,
    isOpen: boolean,
    user: IUser
}

class Moderators extends CoreComponent<any, IState> {
    state: IState = {
        supers: [],
        admins: [],
        moderators: [],
        isLoading: true,
        isOpen: false,
        user: null
    }

    constructor(props: any) {
        super(props);

        this.handleModal = this.handleModal.bind(this);
    }

    async componentWillMount() {
        this.loadHolders();
    }

    async loadHolders() {
        this.setState({
            isLoading: true,
        }, async () => {
            let url = null;

            url = `${config.api}/staff`;

            let res = await Axios.get(url);

            if (!this.isUnmounted) {
                this.setState({
                    supers: res.data.supers,
                    admins: res.data.admins,
                    moderators: res.data.moderators,
                    isLoading: false
                })
            }
        })
    }

    async delete(id: number) {
        if (confirm("Удалить сотрудника?")) {
            let url = null;

            url = `${config.api}/staff/delete?id=${id}`;

            let res = await Axios.get(url);

            if (res.data.status == "success") {
                this.loadHolders();
                toast("Сотрудник удалён", { type: "success" });
            } else {
                toast("При удалении произошла ошибка", { type: "error" });
            }
        }

    }

    handleModal() {
        this.setState({
            isOpen: !this.state.isOpen
        }, () => {
            this.loadHolders();
        });
    }

    render() {
        let { t, auth } = this.props;

        if (!auth.isAuthentificated) return <Redirect to="/login" />;

        return (
            <div className="crm-menu">
                <UserModal isOpen={this.state.isOpen} handleModal={this.handleModal} user={this.state.user} />
                <div className="wrapper">
                    <NavLink className="crm-holders__back" to="/admin">
                        Назад
                    </NavLink>
                    <span className="crm-holders__title">Группы</span>

                    <div className="group-user">
                        <h1 className="group-user__title">
                            Суперадмин <img src="img/Path 75.svg" />
                        </h1>
                        <div className="group-user__items">
                            {this.state.supers.map((user: IUser, i: number) => {
                                return <div className="group-user__item" key={i}>
                                    <span className="group-user__avatar">
                                        <img src="img/userss.svg" />
                                    </span>
                                    <span className="group-user__name">{user.user_profile.first}</span>
                                    <span className="group-user__surname">{user.user_profile.last}</span>
                                    <a className="group-user__edit text-center my-2" onClick={() => {
                                        this.setState({
                                            user
                                        }, () => {
                                            this.handleModal();
                                        })
                                    }}>
                                        редактировать <img src="img/Icon awesome-edit.svg" />{" "}
                                    </a>
                                    {auth.user?.role == "super-admin" || auth.user?.role == "theCreator" && <a className="group-user__edit text-center" onClick={() => {
                                        this.delete(user.id);
                                    }}>
                                        удалить <img src="img/Icon awesome-trash.svg" />{" "}
                                    </a>}
                                </div>;
                            })}
                        </div>
                        <h1 className="group-user__title">
                            Редактор <img src="img/Path 75.svg" />
                        </h1>
                        <div className="group-user__items">
                            {this.state.admins.map((user: IUser, i: number) => {
                                return <div className="group-user__item" key={i}>
                                    <span className="group-user__avatar">
                                        <img src="img/userss.svg" />
                                    </span>
                                    <span className="group-user__name">{user.user_profile.first}</span>
                                    <span className="group-user__surname">{user.user_profile.last}</span>
                                    <a className="group-user__edit text-center my-2" onClick={() => {
                                        this.setState({
                                            user
                                        }, () => {
                                            this.handleModal();
                                        })
                                    }}>
                                        редактировать <img src="img/Icon awesome-edit.svg" />{" "}
                                    </a>
                                    {auth.user?.role == "super-admin" || auth.user?.role == "theCreator" && <a className="group-user__edit text-center" onClick={() => {
                                        this.delete(user.id);
                                    }}>
                                        удалить <img src="img/Icon awesome-trash.svg" />{" "}
                                    </a>}
                                </div>;
                            })}
                        </div>
                        <h1 className="group-user__title">
                            Модератор <img src="img/Path 75.svg" />
                        </h1>
                        <div className="group-user__items">
                            {this.state.moderators.map((user: IUser, i: number) => {
                                return <div className="group-user__item" key={i}>
                                    <span className="group-user__avatar">
                                        <img src="img/userss.svg" />
                                    </span>
                                    <span className="group-user__name">{user.user_profile.first}</span>
                                    <span className="group-user__surname">{user.user_profile.last}</span>
                                    <a className="group-user__edit text-center my-2" onClick={() => {
                                        this.setState({
                                            user
                                        }, () => {
                                            this.handleModal();
                                        })
                                    }}>
                                        редактировать <img src="img/Icon awesome-edit.svg" />{" "}
                                    </a>
                                    {auth.user?.role == "super-admin" || auth.user?.role == "theCreator" && <a className="group-user__edit text-center" onClick={() => {
                                        this.delete(user.id);
                                    }}>
                                        удалить <img src="img/Icon awesome-trash.svg" />{" "}
                                    </a>}
                                </div>;
                            })}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(function (state: any) {
    return {
        auth: state.auth
    };
})(withTranslation()(Moderators));